import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  openModal,
  closeModal,
} from "../../../store/slices/editModalExamsSlice";
import { FaPencilAlt } from "react-icons/fa";
import { FaRegCircleXmark } from "react-icons/fa6";
import Select from "react-select";
import {
  fetchDataExams,
  updateDataExams,
} from "../../../store/slices/apiExamsSlice";
import { fetchDataCategories } from "../../../store/slices/apiCategorySlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditModalExams = ({
  id,
  title,
  submitButtonText,
  examsName,
  examsCategoryId,
  premiumStatus,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const dataExams = useSelector((state) => state.apiExams.data.data);
  const categoryOptions = useSelector((state) => state.apiCategory.data);
  const isOpen = useSelector((state) => state.editModalExams[id] === true);

  const [changeExamsName, setChangeExamsName] = useState("");
  const [changeExamsCategory, setChangeExamsCategory] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [showId, setShowId] = useState("");
  const [premiumExams, setPremiumExams] = useState(false);

  useEffect(() => {
    dispatch(fetchDataExams());
    dispatch(fetchDataCategories());
  }, []);

  const handlePremiumExams = (isChecked) => {
    setPremiumExams(isChecked);
  };

  const handleOpenModal = () => {
    if (Array.isArray(dataExams)) {
      const itemToEdit = dataExams.find((item) => item.id === id);

      if (itemToEdit) {
        setChangeExamsName(itemToEdit.name);
        setChangeExamsCategory(itemToEdit.categoryId);
        setShowId(itemToEdit.categoryName);
        setPremiumExams(itemToEdit.isPremium === 1);
      }
    } else {
      console.error("Expected dataExams to be an array, but got:", dataExams);
    }

    dispatch(openModal(id));
  };

  const handleCloseModal = () => {
    dispatch(closeModal(id));
  };

  const handleOptionChange = (selectedOptions) => {
    setSelectedOption(selectedOptions);
  };

  const handleEditItem = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const selectedCategoryId = selectedOption ? selectedOption.value : null;

    const updatedData = {
      name: changeExamsName,
      categoryId: selectedCategoryId,
      isPremium: premiumExams ? 1 : 0,
    };

    await dispatch(updateDataExams({ id: id, updatedData }));
    toast.success("Te dhenat jan ruajtur me sukses!");
    await dispatch(fetchDataExams());
    if (typeof onSuccess === 'function') {
      onSuccess();
    }
    handleCloseModal();
  };

  return (
    <div>
      <button
        data-modal-target="popup-modal"
        data-modal-toggle="popup-modal"
        onClick={handleOpenModal}
        aria-label="Edit item"
        className="p-1"
      >
        <FaPencilAlt style={{ width: 20, height: 20 }} />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6 overflow-auto">
          <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>

          <div
            className="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-auto overflow-y-auto"
            style={{ maxHeight: "90vh" }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
          >
            <button
              type="button"
              onClick={handleCloseModal}
              className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center z-10"
              aria-label="Close modal"
            >
              <FaRegCircleXmark style={{ width: 20, height: 20 }} />
            </button>

            <div className="p-6 text-center">
              <h3
                id="modal-title"
                className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400"
              >
                {title}
              </h3>

              <form className="space-y-6 text-start" onSubmit={handleEditItem}>
                <div>
                  <label
                    htmlFor="examsName"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    {examsName}:
                  </label>
                  <input
                    type="text"
                    name="examsName"
                    id="examsName"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder=""
                    value={changeExamsName}
                    onChange={(e) => setChangeExamsName(e.target.value)}
                    required
                  />
                </div>

                {examsCategoryId && (
                  <div>
                    <label
                      htmlFor="examsCategoryId"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      {examsCategoryId}:
                      <div className="text-gray-400 mt-1">
                        Kategoria e zgjedhur aktuale:{" "}
                        <span className="text-red-400 font-light">
                          {showId}
                        </span>
                      </div>
                    </label>
                    <Select
                      isClearable
                      name="examsCategoryId"
                      id="examsCategoryId"
                      value={selectedOption}
                      onChange={handleOptionChange}
                      options={categoryOptions.map((option) => ({
                        value: option.id,
                        label: option.name,
                      }))}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    />
                  </div>
                )}

                {premiumStatus && (
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Premium:
                    </label>
                    <div className="flex flex-wrap gap-2">
                      <button
                        type="button"
                        className={`text-sm rounded-lg px-3 py-1 ${
                          premiumExams
                            ? "bg-green-500 text-white"
                            : "bg-gray-200 text-gray-700"
                        }`}
                        onClick={() => handlePremiumExams(true)}
                      >
                        Po
                      </button>
                      <button
                        type="button"
                        className={`text-sm rounded-lg px-3 py-1 ${
                          !premiumExams
                            ? "bg-red-500 text-white"
                            : "bg-gray-200 text-gray-700"
                        }`}
                        onClick={() => handlePremiumExams(false)}
                      >
                        Jo
                      </button>
                    </div>
                  </div>
                )}

                <div className="flex justify-center flex-wrap gap-3 mt-6">
                  <button
                    data-modal-hide="popup-modal"
                    type="submit"
                    className="text-white bg-blue-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    {submitButtonText}
                  </button>

                  <button
                    data-modal-hide="popup-modal"
                    type="button"
                    onClick={handleCloseModal}
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Anulo
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditModalExams;
